export function validatePhone(value: string): string | null {
    const phone = value.replace(/[^0-9]/gmi, '');
    return phone.length === 11 ? '7' + phone.slice(1)
        : null;
}